<template>
  <div :style="{ backgroundImage: `url(${info_banner.image.webp}), url(${info_banner.image.source})` }" class="relative bg-no-repeat h-[400px] md:h-auto bg-cover md:bg-contain w-full md:aspect-[2.56] max-w-[1400px] mx-auto broder mt-[-66px]">

    <div class="absolute top-[66px] left-[7%] md:left-[8.5%] w-[70%] md:w-1/2 h-[calc(100%-66px)] flex flex-col justify-center">
      <h3 class=" text-charcoal text-[28px] lg:text-[40px] font-medium m-0">
        {{info_banner.title }}
      </h3>
      <div class=" text-charcoal text-[18px] lg:text-[24px] leading-[32px] font-light">
        {{ info_banner.sub_title }}
      </div>
      <a :href="info_banner.link" :title="info_banner.link_title" role="button" class="hidden text-[18px] leading-[20px] text-white font-medium px-[28px] py-[14px] transition bg-lime-green hover:bg-lime-green-hover  lg:block w-max mt-[32px] rounded-[8px]">
        {{ info_banner.link_title }}
      </a>
    </div>
    <a :href="info_banner.link" :title="info_banner.link_title" class="absolute inset-0 lg:hidden"></a>
  </div>
</template>
<script>

export default {
  //TODO set banner height to 500px or 450px
  name:  "Info",
  props: [
    'in18',
    'info_banner',
  ],
}
</script>